import { useState, useEffect } from "react";

const KEY = "mc_cookie_ok";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-6 left-6 right-6 md:left-6 md:right-auto md:max-w-md z-[55] animate-fade-up md:bottom-8"
    >
      <div className="glass-panel rounded-2xl p-5 shadow-2xl">
        <div className="text-sm font-bold text-[#1c1f1a] mb-2">
          Utilizziamo i cookie
        </div>
        <p className="text-xs text-[#4a4f47] leading-relaxed mb-4">
          Questo sito utilizza cookie tecnici per garantire la migliore
          esperienza di navigazione. Continuando a navigare accetti la nostra{" "}
          <a href="/privacy" className="text-[#5ab500] hover:underline font-semibold">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex gap-2">
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="flex-1 px-4 py-2 rounded-lg bg-[#5ab500] text-white text-xs font-bold hover:bg-[#4a9a00] transition"
          >
            Accetta
          </button>
          <a
            href="/privacy"
            data-testid="cookie-info"
            className="px-4 py-2 rounded-lg border border-black/15 text-[#1c1f1a] text-xs font-semibold hover:border-[#5ab500] hover:text-[#5ab500] transition"
          >
            Maggiori info
          </a>
        </div>
      </div>
    </div>
  );
}
